export default __webpack_public_path__ + "static/media/bkd-img.8110dc1c.jpg";